import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import Paging from '../../../component/Inc/Paging';
import Tab from '../../../component/Inc/Tab';
import PopFirstClassReport from '../_PopFirstClassReport';
function FirstClassReport() {
  const [modalFirstClassReport, setModalFirstClassReport] = useState(false);
  const [detailTabIdx, setDetailTabIdx] = useState(0);
  const detailTab = [
    {title: '첫 수업 보고서', value: 0},
    {title: '모니터링 보고서', value: 1}
  ];
  return (
    <main className="com_container p_first_class_detail">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_3">
            학생관리
            <span className="bar" />
            <span className="point_txt">첫 수업 보고서 (홍학생103ㆍ경기고1ㆍ남)</span>
          </h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalFirstClassReport(true)} className="com_btn orange s btn_plus">
              첫 수업 보고서 작성
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          {/* 수업정보 */}
          <section className="box">
            <table className="com_board_list">
              <colgroup>
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="10%" />
                <col width="13%" />
                <col width="13%" />
                <col width="10%" />
                <col width="10%" />
              </colgroup>
              <thead>
                <tr>
                  <th>과목</th>
                  <th>상태</th>
                  <th>학교</th>
                  <th>지역</th>
                  <th>지점/학년/계열</th>
                  <th>첫 수업일</th>
                  <th>교사</th>
                  <th>담임</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>수학(1T)</td>
                  <td className="td_red">첫수업</td>
                  <td>서울고</td>
                  <td>경기도</td>
                  <td>본사/재수/인문</td>
                  <td>2022.09.02</td>
                  <td>가선생102</td>
                  <td>가담임102</td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>수학(1T)</td>
                      <td className="td_point">종료</td>
                      <td>서울고</td>
                      <td>경기도</td>
                      <td>본사/재수/인문</td>
                      <td>2022.09.02</td>
                      <td>가선생102</td>
                      <td>가담임102</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 담당 학생 */}
          <section className="box">
            <div className="detail_tit dot">보고서 상세</div>
            <Tab data={detailTab} tab={detailTabIdx} setTab={setDetailTabIdx} tabStyle="full" />
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count">
                <button className="btn_edit" />
                <button className="btn_delete" />
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">
                    <button className="name btn_link">홍길동103 </button>
                    (고3ㆍ경기고등학교ㆍ본사)
                  </span>
                </div>
                <div className="info">
                  <span className="tit">연락처</span>
                  <div className="cont">
                    <p className="txt">010-1234-233</p>
                    <p className="txt">
                      <span>부)010-1234-233</span>
                      <span className="dot" />
                      <span>모)010-1234-233</span>
                    </p>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">첫 수업일시</span>
                  <span className="cont">2023.05.10 12:30</span>
                </div>
                <div className="info">
                  <span className="tit">다음 수업일시</span>
                  <span className="cont">2023.05.10 12:30</span>
                </div>
                <div className="info">
                  <span className="tit">교사</span>
                  <span className="cont">
                    <button className=" btn_link">김교사302</button>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">담임</span>
                  <span className="cont">
                    <button className=" btn_link">김담임302</button>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업 방법</span>
                  <span className="cont">대면</span>
                </div>
                <div className="info">
                  <span className="tit">수업 과목</span>
                  <span className="cont">과탐</span>
                </div>
                <div className="info">
                  <span className="tit">기수 / 타임</span>
                  <span className="cont">2기 / 2T</span>
                </div>
                <div className="info">
                  <span className="tit">이지교재</span>
                  <span className="cont">교재명</span>
                </div>
              </div>
              <div className="com_board_box">
                <div className="board_item">
                  <div className="info">
                    <span className="tit">수업 도착시간</span>
                    <span className="cont">
                      지각 <span className="dot" /> 30분
                    </span>
                  </div>
                  <div className="info">
                    <span className="tit">지각시 통화 여부</span>
                    <span className="cont">통화함</span>
                  </div>
                  <div className="info">
                    <span className="tit">학생반응</span>
                    <span className="cont">매우긍정</span>
                  </div>
                  <div className="info">
                    <span className="tit">수업이해도</span>
                    <span className="cont">보통</span>
                  </div>

                  <div className="info">
                    <span className="tit">등급 수준</span>
                    <span className="cont ">2~3 등급</span>
                  </div>
                  <div className="info">
                    <span className="tit">학부모 반응</span>
                    <span className="cont ">대체로 긍정</span>
                  </div>
                  <div className="info">
                    <span className="tit">수업진행가능성</span>
                    <span className="cont">매우긍정</span>
                  </div>
                  <div className="info">
                    <span className="tit">상담내용</span>
                    <span className="cont">학습계획</span>
                  </div>
                  <div className='info'>
                    <span className='tit'>지각시 통화여부</span>
                    <span className='cont'>통화안함</span>
                  </div>
                  <hr className="com_divider" />
                  <div className="info">
                    <span className="tit">문제점</span>
                    <span className="cont ">없음</span>
                  </div>
                  <div className="info">
                    <span className="tit">메모</span>
                    <span className="cont">-</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">김담임102 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">수고하셨습니다.</div>
              </div>
            </div>
            <div className="com_board_box">
              <textarea name="" className="textarea" placeholder="내용 입력" />
            </div>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">등록</button>
            </div>
          </section>
        </section>
      </div>
      <PopFirstClassReport open={modalFirstClassReport} close={() => setModalFirstClassReport(false)} />
    </main>
  );
}

export default FirstClassReport;
